import type { SVGProps } from 'react';
export const IconStoresApple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.2027 16.64C21.2212 15.0846 22.0798 13.6442 23.4645 12.8223C22.5874 11.6204 21.1658 10.887 19.6333 10.8428C18.0176 10.6837 16.4574 11.7619 15.6358 11.7619C14.8141 11.7619 13.5309 10.8516 12.1738 10.8781C10.3827 10.9312 8.7486 11.8855 7.8808 13.3879C6.02521 16.4632 7.41007 20.9878 9.19174 23.4711C10.078 24.6906 11.1213 26.0515 12.4783 25.9985C13.8078 25.9454 14.3063 25.1855 15.9128 25.1855C17.519 25.1855 17.9714 25.9985 19.3563 25.972C20.7872 25.9454 21.6827 24.7525 22.5413 23.5153C23.1784 22.6492 23.6768 21.6859 24 20.6696C22.3013 19.9804 21.2027 18.3897 21.1935 16.6312L21.2027 16.64Z"
      fill="currentColor"
    />
    <path
      d="M18.5807 9.20788C19.3563 8.31532 19.744 7.15767 19.6516 6C18.4607 6.12372 17.3621 6.66278 16.5681 7.52882C15.7927 8.3772 15.3957 9.49066 15.4695 10.6218C16.6789 10.6307 17.8237 10.1181 18.5807 9.21671V9.20788Z"
      fill="currentColor"
    />
  </svg>
);
